<ion-app>
  <!-- Initialization loader overlay -->
  <div class="init-loader-overlay" *ngIf="isInitializing">
    <div class="init-loader-content">
      <ion-spinner name="crescent"></ion-spinner>
    </div>
  </div>
  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>
